export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "indexWorker_d5ed3b5.worker.js");
}
